import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import OrganisationSelect from 'view/component/form-items/organisation-select'

const UserOrgSelect = ({ organisations, disabled }) => {
  return (
    <OrganisationSelect
      disabled={disabled}
      organisations={organisations}
    />
  )
}

UserOrgSelect.propTypes = {
  disabled: PropTypes.bool,
  organisations: PropTypes.array
}

const mapStateToProps = (state) => ({
  organisations: state.organisation.organisations
})

export default connect(mapStateToProps)(UserOrgSelect)
